import {Component, OnDestroy, OnInit} from '@angular/core';
import {AnnouncementsService} from '../../services/announcements.service';
import {UrlService} from '../../services/url.service';
import {AccountPermissionsService} from '../../services/account-permissions.service';
import {ActivatedRoute} from '@angular/router';
import {IAnnouncementRules} from '../../types/announcement-rules';
import {flatMap, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
    selector: 'announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit, OnDestroy {

    onDestroyNotifier: Subject<any> = new Subject();

    rules: IAnnouncementRules;

    constructor(
        public announcementService: AnnouncementsService,
        public urlService: UrlService,
        public account: AccountPermissionsService,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.rules = this.route.snapshot.data.rules;

        if (this.rules.hasEnabledWebsites) {
            this.urlService.onUrlChange.pipe(
                flatMap(
                    () => this.announcementService.getDataByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange))
                ),
                takeUntil(this.onDestroyNotifier)
            ).subscribe();
        }

        this.urlService.setQueryParams(this.announcementService.defaultTabId);
    }

    ngOnDestroy(): void {
        this.onDestroyNotifier.next();
        this.onDestroyNotifier.complete();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements.component.ts